export const synopsisParagraphs = [
  '故事从“重逢”开始。几位大学时代的老同学在多年之后重新联系上彼此，有人主动张罗起这场迟到的聚会。名义上大家是为了追忆青春，但坐下来之后才发现，真正想说的从来不是当年那点旧事，而是如今过得怎么样。',
  '聚会选在郊外一处相对封闭的空间，白天还维持着体面的寒暄，到了夜里，酒过几巡，婚姻里的倦怠、工作的压力、没兑现的承诺，一句一句被摆上桌面。有人借着酒意去补当年没说完的话，有人只是想短暂逃离那个已经变得乏味的家。',
  '随着系列推进，故事的重心也从“情感”滑向“算计”。当同学关系被当成重新进入他人生活的捷径，信任就变成了最贵的筹码。一边是旧情与现实互相拉扯，一边是熟人社会里逐渐收不回来的秘密，几条线最终同时走向收束。',
];

export const synopsisHighlights = [
  {
    icon: 'ri-door-open-line',
    title: '一场名为叙旧的重逢',
    desc: '表面是追忆青春，实际是成年人各自现实困境的一次集中投放。',
  },
  {
    icon: 'ri-goblet-line',
    title: '酒桌即战场',
    desc: '密闭空间里的对话层层递进，关系边界在一杯接一杯之间被悄悄推远。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '情感与算计并行',
    desc: '系列后段从情感越界延伸到金钱骗局，让“信任”成为最大的变量。',
  },
];

export const storyMainline = [
  {
    stage: '第一幕 · 重逢',
    title: '把自己重新塞回同一张桌子',
    desc: '多年未见的同窗重新聚到一起，旧日的暗恋与遗憾被重新点亮，为后续所有关系线埋下引线。',
  },
  {
    stage: '第二幕 · 越界',
    title: '从试探到失控',
    desc: '酒桌与深夜的对话让边界变得模糊，情感越界发生，几个家庭同时出现裂缝。',
  },
  {
    stage: '第三幕 · 算计',
    title: '信任被摆上台面',
    desc: '故事转向带有讽刺色彩的骗局线，有人以理财投资为名重新靠近老同学。',
  },
  {
    stage: '第四幕 · 收束',
    title: '代价逐一到来',
    desc: '骗局与秘密同时逼近暴露，每个人都必须为自己的选择买单，关系网被重新洗牌。',
  },
];